var path    = "https://conceptodohaapp.com/concepto_version2/";
var shopurl = Shopify.shop;
var ip_address = "";
var customer_id = "";

var STOP_ALL_API_CALLS = false;  // <<-- TURN THIS OFF to resume functionality

if (!window.jQuery) {
    var imported = document.createElement('script');
    imported.src = 'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.0/jquery.min.js';
    imported.onload = function() {
        initializeCustomizer();
    };
    document.head.appendChild(imported);
} else {
    initializeCustomizer();
}

function initializeCustomizer() {

$(document).ready(function($) {

    var currenturl = window.location.href;
    var find = 'products/';

    if (currenturl.indexOf(find) != -1) {

        var variant_id = $("#ProductSelect-product-template").val();
        customer_id = $("#customer_id").val();

        if (!STOP_ALL_API_CALLS) {
            $.getJSON('https://jsonip.com').done(function(data) {
                ip_address = data.ip;
                get_custom_design_settings(variant_id);

                $('<input>').attr({
                    type: 'hidden',
                    id: 'ip_address',
                    value: ip_address
                }).appendTo('body');
            });
        }
    }

    $('#save-settings-button1').click(function () {

        if (STOP_ALL_API_CALLS) return false;

        var product = yourDesigner.getProduct();
        var variant_id = $("#ProductSelect-product-template").val();

        $.ajax({
            url: path+'/homepage/save_customer_case_setting',
            type: 'post',
            data: { variant_id: variant_id, customer_id: customer_id, ip_address: ip_address, customize_settings: product },
            success: function () {
                $(".setting_saved_message").show().fadeOut(3500);
            }
        });

        return false;
    });

});

$(document).on("click","#save-settings-button", function(){

    if (STOP_ALL_API_CALLS) return false;

    var product = yourDesigner.getProduct();
    var variant_id = $("#ProductSelect-product-template").val();
    var ip_address_new = $("#ip_address").val();

    $.ajax({
        url: path+'/homepage/save_customer_case_setting',
        type: 'post',
        data: { variant_id: variant_id, customer_id: customer_id, ip_address: ip_address_new, customize_settings: product },
        success: function () {
            $(".setting_saved").show().fadeOut(3500);
        }
    });

    return false;
});

} // initializeCustomizer
